import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceEditProjectNotificationState = createStateReducer(initialState, {
  [events.editProjectSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editProject",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.editProjectFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editProject",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceEditProjectNotificationState };
